(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches || !('IntersectionObserver' in window)) return;
  const selector = '.s8-concept .section-heading, .catalog-card, .feature-grid>article, .s8-concept .split-copy, .s8-concept .review-section, .s8-concept .journal-heading, .journal-grid>article, .s8-concept .final-cta, .s8-story-split, .s8-steps>article, .s8-how, .s8-compare, .s8-story-cta, .s8-details>div>article';
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.remove('s8-reveal-pending');
      entry.target.classList.add('s8-reveal-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08 });
  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach(element => {
      if (element.dataset.s8Motion) return;
      element.dataset.s8Motion = 'true';
      // Only prepare content below the screen; visible content paints immediately.
      if (element.getBoundingClientRect().top < innerHeight) return;
      const siblings = [...element.parentElement.children];
      element.style.setProperty('--s8-reveal-delay', Math.min(siblings.indexOf(element) % 3, 2) * 70 + 'ms');
      element.classList.add('s8-reveal-pending');
      observer.observe(element);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  preference.addEventListener('change', event => {
    if (!event.matches) return;
    observer.disconnect();
    document.querySelectorAll('.s8-reveal-pending').forEach(element => element.classList.remove('s8-reveal-pending'));
  });
})();
